export type AffiliatedWith = 'ANVR' | 'SGR';

export enum AffiliatedWithTypes {
	ANVR = 'ANVR',
	SGR = 'SGR',
}
